/** @file /login: username + password form posting to /auth/login; errors shown translated by code. */
import { useState, type SubmitEvent } from 'react';
import { api } from '../api/api';
import { formField } from '../shell/formField';
import { errorText } from '../shell/i18n/errorText';
import { useT } from '../shell/i18n/useT';
import { signIn } from '../shell/session/signIn';

/** After a successful sign-in the route guard in App leaves /login; the button is disabled while a sign-in runs. */
export function LoginScreen() {
  const t = useT();
  const [failure, setFailure] = useState<{ thrown: unknown } | null>(null);
  const [pending, setPending] = useState(false);
  const onSubmit = (event: SubmitEvent<HTMLFormElement>): void => {
    event.preventDefault();
    if (pending) return;
    const form = new FormData(event.currentTarget);
    setFailure(null);
    setPending(true);
    signIn(api, formField(form, 'username'), formField(form, 'password'))
      .catch((thrown: unknown) => { setFailure({ thrown }); })
      .finally(() => { setPending(false); });
  };
  return (
    <main className="shell-center">
      <form className="shell-card shell-form" onSubmit={onSubmit}>
        <h1>{t('login.title')}</h1>
        <label>{t('login.username')}<input name="username" required /></label>
        <label>{t('login.password')}<input name="password" type="password" required /></label>
        {failure === null ? null : <p role="alert" className="shell-error">{errorText(t, failure.thrown)}</p>}
        <button type="submit" disabled={pending}>{t('login.submit')}</button>
      </form>
    </main>
  );
}
